<template>
  <div class="app" v-if="user">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile/>

      <img class="navbar-brand-full  d-md-block logo-m"  :src="logoUrl" alt="Logo">
      <SidebarToggler class="d-md-down-none"  display="sm"/>
      <div class="unicef-inter-logo">
        <img class="navbar-brand-full d-sm-none d-md-block " style="height: 4rem" src="img/logo/logo_bijeli.png"
             alt="unicef">
      </div>
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="">
          <DefaultHeaderDropdown/>
        </b-nav-item>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <nav class="sidebar-nav">
          <section class="ps-container scroll-area ps ps--theme_default ps--active-y">
            <ul class="nav">
              <li class="nav-item" v-if="checkRoutePermission({url: '/recommendations'})" >
                <router-link class="router-link-exact-active  nav-link"  :to="{name: routerName.RN_RECOMMENDATION_LIST}">
                  <i class="nav-icon fa fa-thumbs-up"></i>
                  {{$t('RECOMMENDATIONS')}}
                </router-link>
              </li>
                <li class="nav-item" v-if="checkRoutePermission({url: '/competent-authorities'})" >
                  <router-link class="router-link-exact-active  nav-link"  :to="{name: routerName.RN_COMPETENT_AUTHORITIES}">
                    <i class="nav-icon icon-home"></i>
                    {{$t('COMPETENT_AUTHORITIES')}}
                  </router-link>
                </li>
                <li class="nav-item" v-if="checkRoutePermission({url: '/users'})" >
                  <router-link class="router-link-exact-active  nav-link"  :to="{name: routerName.RN_USER_LIST}">
                    <i class="nav-icon icon-user"></i>
                    {{$t('USERS')}}
                  </router-link>
                </li>
            </ul>
          </section>
        </nav>
        <b-button @click="logout" class="btn-logout ml-4"><i class="fa fa-power-off" aria-hidden="true"></i>{{$t("LOGOUT")}}
        </b-button>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <!--<Breadcrumb :list="list"/>-->
        <div class="container-fluid">
          <page-transition>
            <router-view class="mt-3"></router-view>
          </page-transition>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>

<!--      <b-col cols="12">
        <span>Admin sistema: „MS Global Equity“ <a style="color: #ea2f30" href="https://management-solutions.biz/">www.management-solutions.biz</a> </span>
        <span class="ml-3">Telefon: +387 51 491 555</span>
        <span class="ml-3">Email: <a style="color: #ea2f30" href="mailTo:office@management-solutions.biz">office@management-solutions.biz</a> </span>
      </b-col>-->

      <b-col cols="3" class="text-right">
      </b-col>

    </TheFooter>
  </div>
</template>
<style>
  .app-footer{
    background:#ffffff;
    margin-left: 1rem;
  }
  .scroll-area{
    position: absolute;
    height: 100%;
    margin: auto;
  }
  .logo-wrapper {
    margin-left: -1rem;
  }
</style>

<script>
  import nav from '@/_nav'
  import * as r_permission from '@/shared/route_permission'
  import store from '@/store/store'
  import {
    Header as AppHeader,
    SidebarToggler,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
    Aside as AppAside,
    AsideToggler,
    Footer as TheFooter,
    Breadcrumb
  } from '@coreui/vue'
  import DefaultAside from './DefaultAside'
  import DefaultHeaderDropdown from './DefaultHeaderDropdown'
  import PageTransition from '@/components/app/transition/AppTransition'
  import {USER_DATA} from '@/shared/constants.js'
  import routerName from '@/router/routeNames'
  import AppButton from "@/components/app/AppButton";
  import {cloneDeep} from 'lodash'
  import {LoginPage} from "@/shared/constants";
  import routeNames from "@/router/routeNames";
  import {mapGetters} from "vuex";

  export default {
    name: 'DefaultContainer',
    data() {
      return {
        r_permission,
        routerName,
        navList:[],
      }
    },
    components: {
      AppButton,
      AsideToggler,
      AppHeader,
      AppSidebar,
      AppAside,
      TheFooter,
      Breadcrumb,
      DefaultAside,
      DefaultHeaderDropdown,
      SidebarForm,
      SidebarFooter,
      SidebarToggler,
      SidebarHeader,
      SidebarNav,
      SidebarMinimizer,
      PageTransition
    },
    computed: {
      ...mapGetters('client', ['availableClientList']),
      ...mapGetters('client', ['availableClientList']),
      ...mapGetters('user', ['currentLanguage']),
      name() {
        return this.$route.name
      },
      user() {
        return store.getters['user/getUser']
      },
      logoUrl() {
        return this.currentLanguage === 'sr' ?  'img/logo/logo_ministarstvo_cr.png' : 'img/logo/logo_minitstarstvo_la.png'
      },
      list() {
        return this.$route.matched.filter((route) => route.meta.label)
      },
      navigation_list() {

          return this.navList.items.reduce((result, el) => {
            if (this.checkRoutePermission(el)) {
              result.push(el);
            }
            return result;
          }, []);

      },
    },
    methods: {
      logout() {
        this.$store.dispatch('auth/actionLogout').then(() => {
          if (process.env.NODE_ENV === 'production') {

            window.location.href = LoginPage

          } else {
            this.$router.replace({name: routeNames.RN_LOGIN})
          }
        })
      },
      checkRoutePermission(navItem) {
        if (!navItem.url) return
        const routeMeta = this.$router.resolve(navItem.url).route.meta || {}
        const hasPermission = (typeof (routeMeta.permission_id) === 'undefined' || this.checkPermission(routeMeta.permission_id))
        return hasPermission
      }
    },
    created(){
      this.navList = cloneDeep(nav)
    },
    beforeRouteEnter(to, from, next) {

      if (window.location !== window.parent.location) {
        window.parent.location.replace(to.fullPath)
      } else {
        next(() => {
          document.body.classList.remove('page-login')

        })
      }
    },

  }
</script>
<style>
@media (max-width: 991.98px) {
  .unicef-inter-logo {
    display: none !important;
  }
}
@media (max-width: 471.98px) {
  .logo-m {
    height: 2.5rem
  }
}
@media (max-width: 387.98px) {
  .logo-m {
   display: none;
  }
}
</style>
